// Recovered compiled webpack factory 60075. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    let t = 5381;
    for (let r = 0; r < e.length; r++) t = ((t << 5) + t + e.charCodeAt(r)) | 0;
    return t >>> 0;
  }
  function n(e) {
    return r(e).toString(36).slice(0, 5);
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      djb2Hash: function () {
        return r;
      },
      hexHash: function () {
        return n;
      },
    }));
}
